import { AuthType } from '@notes/webintegrations-common'
import { Errors } from '../logger/Errors'
import { Log } from '../logger/Log'

export class RefreshTokenForSdkActivity {
  private start: number
  private authType: AuthType | undefined

  constructor(authType: AuthType | undefined) {
    this.start = Date.now()
    this.authType = authType
  }

  public finishWithSuccess(): void  {
    Log.logger.logReportData('RefreshTokenForSdkActivity', false /* isCriticalEvent */,  {
      'Success': true,
      'SuccessRate': 1,
      'Duration': Date.now() - this.start,
      'AuthType': this.authType ? this.authType : '',
    })
  }

  public finishWithFailure(errorBucket: string, error?: Error): void {
    Log.logger.logReportData('RefreshTokenForSdkActivity', false /* isCriticalEvent */, {
      'Success': false,
      'SuccessRate': 0,
      'Duration': Date.now() - this.start,
    } /* payloadNonPII */, {
      'ErrorName': error ? error.name : '',
      'ErrorMessage': error ? error.message : '',
      'ErrorBucket': errorBucket,
      'AuthType': this.authType ? this.authType : '',
    })

    Log.logger.logUnexpected(Errors.getRefreshTokenForSdkError(errorBucket), errorBucket)
  }
}
